import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Link } from '@skatteetaten/ds-buttons';

const FooterLink = /*#__PURE__*/ forwardRef(({ children, ...linkProps }, ref)=>{
    return /*#__PURE__*/ jsx(Link, {
        ref: ref,
        color: 'white',
        ...linkProps,
        children: children
    });
});
FooterLink.displayName = 'FooterLink';

export { FooterLink };
